import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60ba7e50")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DetailStatusCardDashboardClient = _resolveComponent("DetailStatusCardDashboardClient")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    class: _ctx.ableToViewDetail ? 'cursor-pointer card-cod-cancel' : '',
    title: _ctx.$t('dashboard.cancelledCodValue')
  }, {
    default: _withId(() => [
      _createVNode(_component_DetailStatusCardDashboardClient, {
        class: "mt-3",
        colorValue: "text-red-lp-300",
        isValueCurrency: "",
        title: _ctx.$t(_ctx.failedCodValue.title),
        tooltipTitle: _ctx.failedCodValue.tooltip,
        loading: _ctx.failedCodValue.loading,
        value: _ctx.failedCodValue.amount,
        subValue: _ctx.failedCodValue.resi,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickDetail(`cod-${_ctx.failedCodValue.type}`)))
      }, null, 8, ["title", "tooltipTitle", "loading", "value", "subValue"])
    ]),
    _: 1
  }, 8, ["class", "title"]))
})